var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48667 4.66667L9.16546 5.39778L2.6086 12.4444H1.94424V11.7289L8.48667 4.66667ZM11.0863 0C10.9058 0 10.718 0.0777777 10.5808 0.225556L9.25934 1.64889L11.9673 4.56556L13.2888 3.14222C13.5704 2.83889 13.5704 2.33333 13.2888 2.04556L11.599 0.225556C11.4546 0.07 11.2741 0 11.0863 0ZM8.48667 2.48111L0.5 11.0833V14H3.20796L11.1946 5.39778L8.48667 2.48111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.f993d28b.svg";
export { ForwardRef as ReactComponent };